import * as React from "react";
import { DD_MMM_YYYY, formatDate } from "src/utils/dateUtils";
import TimelineItem from "./TimelineItem";
import { Slot } from "src/containers/event/event.types";
import { filter, includes, map } from "lodash-es";

export interface TimelineDataItem {
  slots: Slot[];
  date: string;
}

interface TimelineProps {
  items: TimelineDataItem[];
  children: (item: TimelineDataItem) => React.ReactNode;
}

export const Timeline: React.FC<TimelineProps> = ({ items, children }) => {
  const [openCollapses, setOpenCollapses] = React.useState<string[]>([items[0].date]);

  const handleOnToggle = (date: string): void => {
    const dates: string[] = includes(openCollapses, date)
      ? filter(openCollapses, (s) => s !== date)
      : [...openCollapses, date];

    setOpenCollapses(dates);
  };
  return (
    <ul className="timeline timeline-vertical col-8">
      {map(items, (item) => (
        <TimelineItem
          key={item.date}
          isOpen={includes(openCollapses, item.date)}
          onToggle={() => handleOnToggle(item.date)}
          date={formatDate(item.date, DD_MMM_YYYY)}
        >
          {children(item)}
        </TimelineItem>
      ))}
      <li className="me-2 d-inline-block w-100" />
    </ul>
  );
};
